<script>
  import PrimaryButton from "../../../components/button/generic/PrimaryButton.svelte";
  import HelpTooltip from "../../../components/tooltip/HelpTooltip.svelte";
  import DisplaySerialInfo from "./DisplaySerialInfo.svelte";
  import { translate } from "../../../i18n/i18next.js";

  export let licenses

  /**
   * @params {{
   *   serialNumber: string,
   * }} data
   * @returns {Promise<{}>}
   */
  export let onSerialSelected

  let isRequesting = false
  async function handleClickSelect(serialNumber) {
    isRequesting = true
    await onSerialSelected({serialNumber})
    isRequesting = false
  }
</script>

<div class="list">
  {#each licenses as license}
    <div class="license-container">
      <DisplaySerialInfo license={license} />
      <div class="button">
        {#if license.validityPeriod.isValid.reason === "expired"}
          <HelpTooltip title={translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.licenses.expired.title")}>
            {translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.licenses.expired.caption")}
          </HelpTooltip>
        {:else if license.validityPeriod.isValid.reason === "notStarted"}
          <HelpTooltip title={translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.licenses.notStarted.title")}>
            {translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.licenses.notStarted.caption")}
          </HelpTooltip>
        {:else if license.loginUser}
          <HelpTooltip title={translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.licenses.inUse.title")}>
            {translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.licenses.inUse.caption1")}
            <a style="text-decoration: underline" target="_blank" href={translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.licenses.inUse.caption2Href")}>
              {translate("frontend:components.changeLicenseAuthenticationMethodDialog.selectSerial.licenses.inUse.caption2")}
            </a>
          </HelpTooltip>
        {/if}
        <PrimaryButton
          onClick={() => handleClickSelect(license.serialNumber)}
          disabled={!!license.loginUser || !license.validityPeriod.isValid.ok || isRequesting}
        >
          {translate("generic.select")}
        </PrimaryButton>
      </div>
    </div>
  {/each}
</div>

<style>
  .list {
    width: 100%;
  }
  .license-container {
    padding: 1rem 0;
    border-bottom: 1px solid darkgrey;
    display: flex;
    flex-direction: column;
    gap: .5rem;
  }
  .license-container:is(:first-of-type) {
    border-top: 1px solid darkgrey;
  }
  .button {
    align-self: end;
  }
</style>
